import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./index.module.css";
export const PathElem = ({ name, onClick, }) => {
    return (_jsx("p", Object.assign({ className: styles.pathElem, onClick: onClick }, { children: name })));
};
